<template lang="pug">
	.style-degree-editor.flex-col.space-large
		.flex-col
			.flex-row.align-center.center
				.font-big(v-if="numberValue !== 1") {{$formatNumber(numberValue, 2).replace(',', '.')}}
			.flex-row.space
				DxSlider.flex-1(:min="0.01", :max="2", :step="0.01", :value.sync="numberValue", :show-range="false")
</template>

<script>
	import _ from 'lodash';
	import DxSlider from 'devextreme-vue/slider';

	export default {
		translationCategory: 'insertion.SSMLStyleDegreeEditor',
		name: 'style-degree-editor',
		components: { 
			DxSlider
		},
		model: {
			prop: 'value',
			event: 'change '
		},
		props: ['text', 'value'],
		data() {
			return {
				numberValue: parseFloat(this.value) || 1
			};
		},		
		watch: {
			numberValue(v) {
				if (v) {
					this.$emit('change', this.numberValue);
				}
			}
		},
		mounted() {
			if (__DEBUG__)
				window.styleDegreeEditor = this;

			this.$emitChange = _.debounce(this.emitChange, 500, {
				leading: false,
				trailing: true,
				maxWait: 2000
			});
		},
		methods: {
			emitChange() {
				this.$emit('change', this.numberValue);
			}
		}
	};
</script>
<style lang='scss'>
	.style-degree-editor {

	}
</style>
